const config = {
  // Table Columns
  columns: [
    {
      title: 'Template Name',
      dataIndex: 'name',
      key: 'name',
      width: '180px',
      sorter: true
    }
  ],
  // Filtering
  sorter: {
    field: 'name',
    order: 'ascend'
  },
  filters: {},
  customFilters: {
    name: {
      filterDropdownVisible: false,
      filtered: false,
      contains: true,
      searchFields: ['name'],
      searchValue: ''
    }
  },
  // General
  title: 'Assigned Templates',
  rowSelectionConfig: {
    selectItemOnSingleClick: false,
    selectItemOnDoubleClick: false,
    highlightRow: false
  }
};

export default config;
